import { isDemoModeEnabled, isMswEnabled } from 'shared/lib/env';
import { isSupabaseConfigured } from 'shared/supabase/client';

/** Synthetic API data via MSW (courses, schools, etc.) */
export const isMswDataMode = isMswEnabled();

/** Show demo banner (can be on while using real Supabase auth) */
export const isDemoMode = isDemoModeEnabled();

export async function fetchWithFallback<T>(
  supabaseFetch: () => Promise<T>,
  apiFetch: () => Promise<T>
): Promise<T> {
  // Demo/synthetic data: MSW always wins when enabled
  if (isMswDataMode) {
    return apiFetch();
  }

  if (isSupabaseConfigured) {
    try {
      return await supabaseFetch();
    } catch (err) {
      console.warn('Supabase fetch failed, falling back to API:', err);
      return apiFetch();
    }
  }

  return apiFetch();
}
